import { SectionNewChatPage } from "@/pages/Section";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/app/companies/$company_id/sections/$section_id/new")({
  component: SectionNewChatPage,
});
